import React from 'react';
import Button from '../Button';

import './download-app.css';

const Footer = (props) => {
    return !props.authFromMobile ? (
        <section className="download-apps">
            <div className="content-container">
                <h2>Looking for CircleLoop apps to get started with your account?</h2>
                <a href="https://www.circleloop.com/download"><Button styling="apps-signin">Download the App</Button></a>
            </div>
        </section>
    ) : null;
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/DownloadApp/index.js